"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PEPConfig = _interopRequireDefault(require("./PEPConfig"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @param {HTMLElement} component
 * @param {object} overrideConfig
 * @returns {PEPConfig}
 * @private
 */
var configLoader = function configLoader(component, overrideConfig) {
  if (overrideConfig) return new _PEPConfig["default"](overrideConfig);
  var script = component.querySelector('script[type="application/json"]');

  if (script) {
    try {
      var scriptConfig = JSON.parse(script.innerHTML);
      return new _PEPConfig["default"](scriptConfig);
    } catch (err) {
      console.log('Config error', component, err);
    }
  }

  return new _PEPConfig["default"]({});
};

var _default = configLoader;
exports["default"] = _default;